export default __webpack_public_path__ + "static/media/mask2.9900a99f.jpg";